import { createRoot } from 'react-dom/client'
import ProfilerApp from './ProfilerApp'

const initProfiler = () => {
	const containers = document.querySelectorAll('.js-profiler-container')

	containers.forEach((container) => {
		if (container instanceof HTMLElement && !container.dataset.initialized) {
			const dataStr = container.dataset.profilerData
			if (dataStr) {
				try {
					const data = JSON.parse(dataStr)
					const root = createRoot(container)
					root.render(<ProfilerApp data={data} />)
					container.dataset.initialized = 'true'
				} catch (e) {
					console.error('Failed to parse profiler data', e)
				}
			}
		}
	})
}

// Initialize on DOMContentLoaded and also export for manual calls (e.g. after AJAX)
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initProfiler)
} else {
	initProfiler()
}

// @ts-ignore
window.initProfiler = initProfiler
